export default {
  namespaced: true,
  state:{
    period: { year: null, month: null },
    window: { admin_close_day: null, is_open: false },
    // Generadas las tareas, el período queda cerrado aunque la ventana del administrador
    // siga abierta: bodega ya salió con la ruta.
    tasksGenerated: false,
    orders: [],
    withoutOrder: [],
    summary: { total_orders: 0, open: 0, closed: 0, finalized: 0 }
  },
  getters:{
    period: state => state.period,
    window: state => state.window,
    tasksGenerated: state => state.tasksGenerated,
    orders: state => state.orders,
    withoutOrder: state => state.withoutOrder,
    summary: state => state.summary
  },
  mutations:{
    SET_DATA(state, value){
      state.period = value.period;
      state.window = value.window;
      state.tasksGenerated = value.tasks_generated;
      state.orders = value.orders;
      state.withoutOrder = value.without_order;
      state.summary = value.summary;
    }
  },
  actions:{
    getOrders({ commit }, payload) {
      const params = payload || {};
      return new Promise((resolve, reject) => {
        axios.get('stock/purchase-orders', { params }).then((response) => {
          commit('SET_DATA', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    close({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.patch('stock/purchase-orders/' + id + '/close')
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    reopen({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.patch('stock/purchase-orders/' + id + '/reopen')
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    // El motivo viaja en el cuerpo: axios.delete lo descarta si se pasa como segundo
    // argumento, hay que ponerlo dentro de `data`.
    destroy({ commit }, { id, reason }) {
      return new Promise((resolve, reject) => {
        axios.delete('stock/purchase-orders/' + id, { data: { reason } })
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    closeBulk({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('stock/purchase-orders/close-bulk', payload)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    }
  }
}
